import React, { ReactElement, useState, ReactNode } from 'react'
import { Flex, Text } from 'theme-ui'
import { Svg } from 'ui'
import FeaturesDropdown from './FeaturesDropdown'
import CheckIcon from 'images/homePage/check.svg'
import CloseIcon from 'images/homePage/close.svg'

const FeaturesMobile = ({ data }: { data: (ReactNode | boolean)[][] }): ReactElement => {
  const [selectedDropdownItemIndex, setSelectedDropdownItemIndex] = useState(0)
  const [, ...dropdownData] = data[0] as ReactNode[]
  const [, ...contentData] = data

  return (
    <Flex
      data-testid="features-mobile"
      sx={{
        display: ['flex', 'none'],
        flexDirection: 'column',
      }}
    >
      <FeaturesDropdown
        dropdownData={dropdownData}
        selectedItemIndex={selectedDropdownItemIndex}
        setSelectedItemIndex={setSelectedDropdownItemIndex}
      />
      <Flex sx={{ flexDirection: 'column' }}>
        {contentData.map((item: (ReactNode | boolean)[], index: number) => (
          <Flex
            key={index}
            sx={{
              width: '100%',
              px: '1.6rem',
              py: '1.2rem',
              borderRadius: '8px',
              mt: '1.6rem',
              alignItems: 'center',
              backgroundColor: !selectedDropdownItemIndex ? 'greenApple15' : 'white15',
            }}
          >
            <Svg
              svg={item[selectedDropdownItemIndex + 1] ? CheckIcon : CloseIcon}
              sx={{
                mr: ['0.8rem', '1.6rem'],
                color: !selectedDropdownItemIndex ? 'greenApple' : 'aliceBlue60',
                flexShrink: 0,
              }}
              descriptiveText={
                item[selectedDropdownItemIndex + 1]
                  ? 'Feature is supported'
                  : 'Feature is not supported'
              }
            />
            <Text
              sx={{
                color: !selectedDropdownItemIndex ? 'greenApple' : 'aliceBlue60',
                fontSize: '1.4rem',
              }}
            >
              {item[0]}
            </Text>
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}

export default FeaturesMobile
